<template>
  <div>
    <loader></loader>

    <no-habilitado v-if="!habilitado" perfil="Arkidians"></no-habilitado>


    <div
      v-if="habilitado"
      :style="estilos.categoriaStyle"
      id="categoria"
      style="padding-bottom:30px"
    >
      <div class="mb-3 sombra" style="text-align:center" :style="estilos.categoriaStyleBar">
        <div class="row no-gutters">
          <div class="col-md-12">
 
            <img
              :src="estilos.categoria.imagen_categoria"
              style="width:200px"
              class="card-img"
              alt="categoria"
            />
  
          </div>
          <div class="col-md-12">
            <div class="card-body">
              <h3 class="titulo" style="color: white">{{estilos.categoria.descripcion}}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row" style="justify-content: center">
          <app-activity-complete
            v-for="(activity,index) in actividades"
            :activity="activity"
            v-bind:key="index"
          ></app-activity-complete>
        </div>
      </div>

      <router-link
        v-if="$routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }"
        tag="button"
        class="btn boton-primario"
      >Volver</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Activities from "../activities/ActivityComplete";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";

export default {
  name: "categoria",
  data() {
    return {
      habilitado: false,

      estilos: {
        categoria: {
          color: "F33212",
          imagen: ""
        }
      },
      actividades: []
    };
  },
  props: ["id"],
  methods: {
    buscarCategoria(categoria) {
      fetch(
        this.pathAPI +
          "categorias.php?id_categoria=" +
          categoria +
          "&usuario=" +
          this.userLogged.user
      )
        .then(response => response.json())
        .then(data => {
          this.estilos.categoria = data;
          this.estilos.categoriaStyleBar =
            "background-color: " + data.color + "dd";
          this.estilos.categoriaStyle = "background-color: " + data.color;
          this.estilos.tituloStyle = "color:" + data.color;

          const loader = document.querySelector(".loader");
          loader.className += " hidden";
        });
    },
    buscarActividades(categoria, usuario) {
      var self = this;
      var consulta;
      if (usuario) {
        consulta =
          "cursos.php?usuario=" + usuario + "&id_categoria=" + categoria;
      } else {
        consulta = "cursos.php?id_categoria=" + categoria;
      }
      fetch(self.pathAPI + consulta)
        .then(response => response.json())
        .then(data => {
          self.actividades = data;
        });
    }
  },
  watch: {
    $route(to, from) {
      this.buscarActividades(this.id, this.userLogged.user);
      this.buscarCategoria(this.id);
    }
  },
  computed: {
    ...mapGetters([
      "pathAPI",
      "userLogged",
      "categorias",
      "cursoSeleccionado",
      "categoriaSeleccionada"
    ])
  },
  components: {
    appActivityComplete: Activities,
    Loader: Loader,
    NoHabilitado: NoHabilitado
  },

  mounted: function() {
    this.habilitado = true;
    this.buscarActividades(this.id, this.userLogged.user);
    this.buscarCategoria(this.id);
  }
};
</script>

<style scoped>
#categoria {
  background-image: url(/public/images/site/categoria.svg);
  background-repeat: no-repeat;
  padding-top: 100px;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/sections/ActivitiesCategory.vue